"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAdminUser = getAdminUser;
exports.getToken = getToken;
exports.removeAdminUser = removeAdminUser;
exports.removeToken = removeToken;
exports.setAdminUser = setAdminUser;
exports.setToken = setToken;
var _storageKeys = require("@/constants/storageKeys");
// +----------------------------------------------------------------------
// | A2 [ A2赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------

function getToken() {
  return sessionStorage.getItem(_storageKeys.StorageKeys.ACCESS_TOKEN) || '';
}
function setToken(token) {
  if (token) {
    sessionStorage.setItem(_storageKeys.StorageKeys.ACCESS_TOKEN, token);
  }
}
function removeToken() {
  sessionStorage.removeItem(_storageKeys.StorageKeys.ACCESS_TOKEN);
  sessionStorage.removeItem(_storageKeys.StorageKeys.ADMIN_USER);
}
function getAdminUser() {
  try {
    var raw = sessionStorage.getItem(_storageKeys.StorageKeys.ADMIN_USER);
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
}
function setAdminUser(user) {
  if (user == null) {
    sessionStorage.removeItem(_storageKeys.StorageKeys.ADMIN_USER);
    return;
  }
  sessionStorage.setItem(_storageKeys.StorageKeys.ADMIN_USER, JSON.stringify(user));
}
function removeAdminUser() {
  sessionStorage.removeItem(_storageKeys.StorageKeys.ADMIN_USER);
}